import Grid from '@material-ui/core/Grid';
import React from 'react';
import ReduxFormCheckbox from 'shared/components/ReduxFormCheckbox';
import { Field } from 'redux-form';
import { PropTypes } from 'prop-types';
import { SKIP } from 'redux/domain/Settings/constants';

const GridFormCheckbox = ({ fieldSettings, ...other }) =>
	fieldSettings.fieldStatus === SKIP ? null : (
		<Grid item xs={12} md={6}>
			<Field component={ReduxFormCheckbox} {...other} />
		</Grid>
	);

GridFormCheckbox.propTypes = {
	fieldSettings: PropTypes.shape({
		fieldStatus: PropTypes.string.isRequired,
	}).isRequired,
};

export default GridFormCheckbox;
